import React, { useState, useEffect, useCallback } from 'react'
import { useSelector } from 'react-redux';
import MyJobPost from './MyJobPost.component';
import ReactPaginate from 'react-paginate';

export default function PendingJobs() {

    const [posts, setPosts] = useState("");
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [action, setAction] = useState("");

    // Redux State
    const token = useSelector((state) => state.auth.token);
    const userData = useSelector((state) => state.auth.data);

    useEffect(() => {
        getAllPosts();
    }, [action]);

    const getAllPosts = useCallback(async () => {
        await fetch(
            `${process.env.REACT_APP_BASE_URL}/api/posts?${userData?.role == 3 ? `customer_id=${userData?.id}` : `provider_id=${userData?.id}`}&status=1`,
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
            .then((r) => r.json())
            .then((response) => {
                if (response) {
                    setPosts(response.records.data);
                    setTotalRecords(response.records.total);
                    setPageCount(Math.ceil(response.records.total / response.records.per_page));
                } else {
                    console.log(response);
                }
            });
    }, []);

    const handlePageClick = async (event) => {        
        await fetch(`${process.env.REACT_APP_BASE_URL}/api/posts?page=${event.selected + 1}`, {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "Authorization": `Bearer ${token}`
            }
        })
            .then(r => r.json())
            .then(response => {
                if (response.success) {
                    let filteredData = response.records.data.filter(items => items.status !== 3)
                    setPosts(filteredData);
                    setTotalRecords(response.records.total);
                    setPageCount(Math.ceil(response.records.total / response.records.per_page));
                } else {
                    console.log(response);
                }
            })
    };


    return (
        <>
            <div>
                {posts.length > 0 ? (
                    posts.map((post, idx) => (
                        <MyJobPost 
                            post={post} 
                            key={idx} 
                            setAction={setAction}
                        />
                    ))
                ) : (
                    <p className="text-muted">No Job Found</p>
                )}
                <ReactPaginate
                    breakLabel="..."
                    nextLabel="Next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="< Previous"
                    renderOnZeroPageCount={null}
                    containerClassName={"pagination justify-content-center mt-4"}
                    subContainerClassName={"page-item"}
                    pageClassName="page-item"
                    activeClassName={"active"}
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    nextClassName="page-item"
                    previousLinkClassName="page-link"
                    nextLinkClassName="page-link"
                    disabledClassName="disabled"
                />
            </div>
        </>
    );
}
